import { Media } from '@/src/models/MeidaDto';

export class RecyclingProductDto {
  id: number;
  createdAt: string;
  updatedAt: string;
  deletedAt: string;
  isExposed: boolean;
  isEventProduct: boolean;
  category: string;
  productMedia: Media;
  recyclingProductOptions: RecyclingProductOptions[];
}

export interface RecyclingProductOptions {
  size: string;
  weight: number;
  carbonEmissionReduction: number;
  pineScore: number;
}

export class RecyclingPackageProductDto {
  id: number;
  createdAt: string;
  updatedAt: string;
  deletedAt: string;
  name: string;
  weight: number;
  maximumWeight: number;
  carbonEmissionReduction: number;
  pineScore: number;
  unit: string;
  isForApp: boolean;
  unitKr: string;
}
